/* eslint-disable */
//tslint:disable
export var ERoomCount;

(function (ERoomCount) {
  ERoomCount["FourRoom"] = "fourRoom";
  ERoomCount["OneRoom"] = "oneRoom";
  ERoomCount["Studio"] = "studio";
  ERoomCount["ThreeRoom"] = "threeRoom";
  ERoomCount["TwoRoom"] = "twoRoom";
})(ERoomCount || (ERoomCount = {}));